<tt-page>
    <tt-page-heading ttModel="p2_m_persfacts" ttTranslate></tt-page-heading>
    <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0 height-full">
    <tt-page-heading class="col-xs-12 sp-0" tt-model="p2_m_persfacts" tt-translate></tt-page-heading>
    <tt-grid class="col-xs-12 p-5 flex-1" tt-options="vm.grid" ng-if="vm.model.gridReady"></tt-grid>
</tt-page>-->
